import { Clipboard } from '@capacitor/clipboard'
import { MedirexPdf } from '@/plugins/refactor/classes/MedirexPdf'

export default {
	methods: {
		// format: 'txt' | 'txt_condense' | 'pdf'
		// action: 'copy' | 'open' | 'download'
		async copyPrintResult(resultIds, orderExternalId, filename, format = 'txt', action = 'copy') {
			if (!resultIds?.length || !orderExternalId) return

			try {
				const query = this.$axios.objectToQueryString({
					result_ids: resultIds,
					order_external_id: orderExternalId,
					format
				})

				const { result } = await this.$axios.get_auth_data(`v1/results/file?${query}`)

				this._resultDataAction(result, orderExternalId, filename, action)
			} catch (error) {
				this.$toast.error(error)
			}
		},

		async copyResultData(resultIds, orderExternalId, filename, format = 'txt', action = 'copy') {
			if (!resultIds?.length || !orderExternalId) return

			try {
				const query = this.$axios.objectToQueryString({
					result_ids: resultIds,
					order_external_id: orderExternalId,
					format
				})

				const { result } = await this.$axios.get_auth_data(`v1/results/file?${query}`)

				return result
			} catch (error) {
				this.$toast.error(error)
			}
		},

		async copyPrintRequestResults(orderExternalId, filename, format = 'txt', action = 'copy') {
			if (!orderExternalId) return

			try {
				const query = this.$axios.objectToQueryString({
					format
				})

				const encodedOrderExternalId = encodeURIComponent(orderExternalId)
				const { result } = await this.$axios.get_auth_data(`v1/results/${encodedOrderExternalId}/files?${query}`)

				this._resultDataAction(result, orderExternalId, filename, action)
			} catch (error) {
				this.$toast.error(error)
			}
		},

		async _resultDataAction(result, orderExternalId, filename,  action = 'open') {
			if (action == 'copy') {
				await this._copyResult(result)
				this.$toast.info(this.$t('Výsledok bol skopírovaný'))
			} else if (action == 'open' || action == 'download') {
				const medirexPdf = new MedirexPdf(result, filename || `result-${orderExternalId}.pdf`)

				action == 'download'
					? medirexPdf.download()
					: medirexPdf.open()
			} else {
				this.$toast.error(this.$t('Nepodporovaný formát'))
			}
		},

		async _copyResult(result) {
			let bytes = new Uint8Array(
				atob(result)
					.split('')
					.map((char) => char.charCodeAt(0))
			)
			let string = new TextDecoder('utf-8').decode(bytes)

			await Clipboard.write({
				string: string
			})
		}
	}
}
